import AlertDialog from 'components/Dialog/AlertDialog'
import { useCallback } from 'react'
import { useAppSelector } from 'store/useStoreHook'

function ForceLogoutDialog() {
    const showForceLogoutDialog = useAppSelector(
        (state) => state.auth.showForceLogoutDialog,
    )

    const handleOnClose = useCallback(() => {
        window.location.reload()
    }, [])

    return (
        <AlertDialog open={showForceLogoutDialog} onClose={handleOnClose}>
            Disconnected due to login from another session.
        </AlertDialog>
    )
}

export default ForceLogoutDialog
